/**
 * 高德浏览器定位：取当前城市名（逆地理 addressComponent.city），对齐原 BMap.Geolocation 返回的城市字段用途。
 */
import { loadAmapSdk } from './loader'

const PLUGIN_WAIT_MS = 3000 // 插件加载超时时间
const POSITION_TIMEOUT_MS = 3000 // 定位超时时间

function loadAmapPlugin(AMap: any, pluginName: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const tid = window.setTimeout(
      () => reject(new Error(`高德插件加载超时: ${pluginName}`)),
      PLUGIN_WAIT_MS
    )
    AMap.plugin(pluginName, () => {
      window.clearTimeout(tid)
      resolve()
    })
  })
}

export async function getCityByAmapGeolocation(): Promise<string> {
  if (typeof window === 'undefined') {
    throw new Error('定位仅支持浏览器环境')
  }

  const AMap = await loadAmapSdk()
  await loadAmapPlugin(AMap, 'AMap.Geolocation')

  return new Promise((resolve, reject) => {
    let settled = false
    const overallTimer = window.setTimeout(() => {
      if (settled) return
      settled = true
      reject(new Error('定位超时 3s'))
    }, POSITION_TIMEOUT_MS)

    const geolocation = new AMap.Geolocation({
      enableHighAccuracy: true,
      timeout: POSITION_TIMEOUT_MS,
      convert: true,
      needAddress: true,
      showMarker: false,
      showButton: false,
      showCircle: false,
      panToLocation: false,
      zoomToAccuracy: false,
    })

    geolocation.getCurrentPosition((status: string, result: any) => {
      if (settled) return
      settled = true
      window.clearTimeout(overallTimer)
      if (status === 'complete') {
        const city = result?.addressComponent?.city
        console.log('getCityByAmapGeolocation - 定位城市名:', { city });
        if (city) {
          resolve(String(city))
          return
        }
        reject(new Error('高德定位未返回城市'))
        return
      }
      reject(new Error(`failed${result?.message || status}`))
    })
  })
}
